module.exports = __webpack_public_path__ + "img/08.b0fd871a.png";